import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../Translations';
import CloudDownloadIcon from '../../Cutesies/CloudDownloadIcon';
import { sample } from './sample';
import { exportJsonToCSV } from '../../../Utils/CSV';

const DownloadSample: React.FC = () => {
  const downloadSample = () => exportJsonToCSV(sample, 'import_participants_sample.csv');

  return (
    <div className="flex justify-center">
      <CloudDownloadIcon />
      <button
        type="button"
        onClick={downloadSample}
        className="ml-2 text-base font-semibold text-teal-600 bg-transparent border-none cursor-pointer underline hover:no-underline"
      >
        <T kind="Download sample.csv file" />
      </button>
    </div>
  );
};

export default observer(DownloadSample);
